// extracted by mini-css-extract-plugin
export default {"default":"ValidSummary_default__8Jjgf","valid":"ValidSummary_valid__esoQM","invalid":"ValidSummary_invalid__Fsczh","pending":"ValidSummary_pending__lVUe3"};